import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import ZeusDocumentSupportBanner from "@/widgets/zeus_document_support_banner";
import ZeusDocumentSupportBannerData from "./data/zeus_document_support_banner/data";

import ZeusDocCommonDoclist from "@/widgets/zeus_doc_common_doclist";
import ZeusDocCommonDoclistData from "./data/zeus_doc_common_doclist/data";

import ZeusHomepageFloatRightbar1817 from "@/widgets/zeus_homepage_float_rightbar1817";
import ZeusHomepageFloatRightbar1817Data from "./data/zeus_homepage_float_rightbar1817/data";
import jsonp from "jsonp";
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resourceIdList: ['4', '5'],
      positionId: '3',
      type: 'NPS',
      // customParams: {
      //   nps: {
      //     npsNodeIdLv1: 'CJ_LISTEN_TB_CC',
      //     npsNodeIdLv2: 'CJ_LISTEN_JM_HOMEPAGE',
      //     npsStatus: false,
      //   },
      // }
      customParams: {
        nps: {},
      }
    }
  }
  componentDidMount() {
    jsonp("//passport.jd.com/loginservice.aspx?method=Login", {}, (err, res) => {
      if(res && res.Identity && res.Identity.Name){
        fetch(`//joshome.jd.com/api/checkVenderUser?user=${res.Identity.Name}`)
        .then((response) => response.json())
        .then((response) => {
          if(response.code == '100000') {
            this.setState({
              customParams: {
                nps: {
                  npsNodeIdLv1: 'CJ_LISTEN_JM_ZS',
                  npsNodeIdLv2: 'CJ_LISTEN_JM_ZS_3',
                  npsStatus: true,
                  placement: 'right'
                },
              }
            })
          }
        })
      }
    });
  }
  render() {
    const state = this.state;
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_document_support_banner" data-version="8.0.2">
                <ZeusDocumentSupportBanner {...ZeusDocumentSupportBannerData} />
              </div>

              <div className="jdw-widget" data-name="zeus_doc_common_doclist" data-version="16.0.9">
                <ZeusDocCommonDoclist {...ZeusDocCommonDoclistData} />
              </div>
            </div>
          </div>
        </div>

        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_homepage_float_rightbar" data-version="1.2.1">
                <ZeusHomepageFloatRightbar1817 {...ZeusHomepageFloatRightbar1817Data} />
              </div>
            </div>
          </div>
        </div>
        <shop-common-components
          type={state.type}
          custom-params={JSON.stringify(state.customParams)}
        >
        </shop-common-components>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
